import { classApi } from '@/api'
import CreateClassesModal from '@pages/Admin/Manage/tabs/ClassesPage/components/CreateClassesModal/CreateClassesModal'
import { ComponentProps, FC, useEffect, useRef } from 'react'
import { useAsyncFn } from 'react-use'

interface CreateClassesModalWrapperProps
  extends Pick<ComponentProps<typeof CreateClassesModal>, 'onClose' | 'open'> {
  onSuccess: (classId: number) => void
}

const CreateClassesModalWrapper: FC<CreateClassesModalWrapperProps> = ({
  onClose,
  open,
  onSuccess,
}) => {
  const firstOpenRender = useRef(false)

  const [allFoldersState, doFetchAllFolders] = useAsyncFn(classApi.folders, [])
  const allFolders = allFoldersState.value?.data?.data || []

  useEffect(() => {
    if (!open || firstOpenRender.current) return
    doFetchAllFolders()
    firstOpenRender.current = true
  }, [open])

  return (
    (allFoldersState.loading || !!allFoldersState.value) && (
      <CreateClassesModal
        allFolders={allFolders}
        loadingAllFolders={allFoldersState.loading}
        open={open}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    )
  )
}

export default CreateClassesModalWrapper
